/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { setError } from "../../../../errorHandler";

/**
 * Special API client for marketplace login that doesn't redirect on 401 errors
 * This allows the marketplace login page to handle authentication errors locally
 */
const marketplaceApiClient = () => {
  // Create instance
  const instance = axios.create({
    baseURL: `${process.env.REACT_APP_API_BASE_URL}`,
    headers: {
      "Content-Type": "application/json",
    },
  });

  // Set the AUTH token for any request
  instance.interceptors.request.use(
    (config: any) => {
      // extract token from cookies
      const tokenSession = window.localStorage.getItem("token");
      config.headers.Authorization = tokenSession ? `Bearer ${tokenSession}` : "";
      config.headers["correlation-id"] = uuidv4();
      return config;
    },
    (error) => {
      setError(error);
      return Promise.reject(error);
    }
  );

  // Custom response interceptor that doesn't redirect on 401
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      // Simply reject the promise with the error
      // No redirection on 401 - let the component handle it
      return Promise.reject(error);
    }
  );
  
  return instance;
};

export default marketplaceApiClient();
